<!-- Hero Section -->
<section class="hero-section" role="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <h1 class="hero-title">Oportunidades Laborales</h1>
        <p class="hero-description">
          Descubre las mejores oportunidades profesionales que se adaptan a tu perfil y aspiraciones. 
          Conectamos talento con empresas innovadoras.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">{{ ofertasTrabajo.length }}+</span>
            <span class="stat-label">Ofertas Activas</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">50+</span>
            <span class="stat-label">Empresas</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">15+</span>
            <span class="stat-label">Ciudades</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hero-image">
          <img src="assets/images/career-opportunities.jpg" alt="Oportunidades laborales" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Filtros Section -->
<section class="filters-section" role="search">
  <div class="container">
    <div class="filters-card">
      <h2 class="filters-title">Filtrar Oportunidades</h2>
      <div class="row">
        <div class="col-md-3">
          <label for="ubicacion" class="form-label">Ubicación</label>
          <select id="ubicacion" class="form-select" [(ngModel)]="filtros.ubicacion">
            <option value="">Todas las ubicaciones</option>
            <option *ngFor="let ubicacion of ubicacionesDisponibles" [value]="ubicacion">
              {{ ubicacion }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="tipo" class="form-label">Tipo de Contrato</label>
          <select id="tipo" class="form-select" [(ngModel)]="filtros.tipo">
            <option value="">Todos los tipos</option>
            <option *ngFor="let tipo of tiposDisponibles" [value]="tipo">
              {{ tipo }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="empresa" class="form-label">Empresa</label>
          <select id="empresa" class="form-select" [(ngModel)]="filtros.empresa">
            <option value="">Todas las empresas</option>
            <option *ngFor="let empresa of empresasDisponibles" [value]="empresa">
              {{ empresa }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="estado" class="form-label">Estado</label>
          <select id="estado" class="form-select" [(ngModel)]="filtros.estado">
            <option value="todos">Todos los estados</option>
            <option value="activa">Activas</option>
            <option value="próximamente">Próximamente</option>
            <option value="cerrada">Cerradas</option>
          </select>
        </div>
      </div>
      <div class="filters-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="limpiarFiltros()">
          <i class="fas fa-times" aria-hidden="true"></i>
          Limpiar Filtros
        </button>
        <span class="results-count">
          {{ obtenerOfertasFiltradas().length }} ofertas encontradas
        </span>
      </div>
    </div>
  </div>
</section>

<!-- Ofertas Section -->
<section class="opportunities-section" role="main">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Ofertas Disponibles</h2>
      <p class="section-description">
        Explora las posiciones que tenemos disponibles y encuentra la que mejor se adapte a tu perfil.
      </p>
    </div>
    
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let oferta of obtenerOfertasFiltradas(); let i = index">
        <div class="opportunity-card" role="article" [attr.aria-labelledby]="'oferta-' + i + '-title'">
          <div class="card-header">
            <div class="header-top">
              <span class="estado-badge" [class]="getEstadoClass(oferta.estado)">
                {{ getEstadoText(oferta.estado) }}
              </span>
              <div class="fecha-publicacion">
                <i class="fas fa-calendar-alt" aria-hidden="true"></i>
                {{ oferta.fechaPublicacion | date:'dd/MM/yyyy' }}
              </div>
            </div>
            <h3 id="oferta-{{ i }}-title" class="opportunity-title">{{ oferta.titulo }}</h3>
            <span class="company-name">{{ oferta.empresa }}</span>
          </div>
          
          <div class="card-body">
            <p class="opportunity-description">{{ oferta.descripcion }}</p>
            
            <div class="opportunity-details">
              <div class="detail-item">
                <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
                <span>{{ oferta.ubicacion }}</span>
              </div>
              <div class="detail-item">
                <i class="fas fa-money-bill-wave" aria-hidden="true"></i>
                <span>{{ oferta.salario }}</span>
              </div>
              <div class="detail-item">
                <i class="fas fa-clock" aria-hidden="true"></i>
                <span>{{ oferta.tipo }}</span>
              </div>
            </div>

            <div class="requirements-preview" *ngIf="oferta.requisitos.length > 0">
              <h4 class="requirements-title">Requisitos Principales:</h4>
              <ul class="requirements-list">
                <li *ngFor="let requisito of oferta.requisitos.slice(0, 3)">
                  {{ requisito }}
                </li>
                <li *ngIf="oferta.requisitos.length > 3" class="more-requirements">
                  <em>Y {{ oferta.requisitos.length - 3 }} más...</em>
                </li>
              </ul>
            </div>

            <div class="benefits-preview" *ngIf="oferta.beneficios.length > 0">
              <h4 class="benefits-title">Beneficios:</h4>
              <div class="benefits-tags">
                <span class="benefit-tag" *ngFor="let beneficio of oferta.beneficios.slice(0, 3)">
                  {{ beneficio }}
                </span>
                <span *ngIf="oferta.beneficios.length > 3" class="more-benefits">
                  +{{ oferta.beneficios.length - 3 }} más
                </span>
              </div>
            </div>
          </div>
          
          <div class="card-footer">
            <div class="footer-actions">
              <button 
                type="button" 
                class="btn btn-primary btn-sm"
                (click)="aplicarOferta(oferta)"
                [attr.aria-label]="'Aplicar a ' + oferta.titulo">
                <i class="fas fa-arrow-right" aria-hidden="true"></i>
                <span>Aplicar</span>
              </button>
              
              <div class="secondary-actions">
                <button 
                  type="button" 
                  class="btn btn-outline-secondary btn-sm"
                  (click)="guardarOferta(oferta)"
                  [attr.aria-label]="'Guardar oferta ' + oferta.titulo"
                  title="Guardar oferta">
                  <i class="fas fa-bookmark" aria-hidden="true"></i>
                </button>
                
                <button 
                  type="button" 
                  class="btn btn-outline-secondary btn-sm"
                  (click)="compartirOferta(oferta)"
                  [attr.aria-label]="'Compartir oferta ' + oferta.titulo"
                  title="Compartir oferta">
                  <i class="fas fa-share-alt" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no hay ofertas -->
    <div class="no-results" *ngIf="obtenerOfertasFiltradas().length === 0">
      <div class="no-results-content">
        <i class="fas fa-search" aria-hidden="true"></i>
        <h3>No se encontraron ofertas</h3>
        <p>Intenta ajustar los filtros o vuelve más tarde para nuevas oportunidades.</p>
        <button type="button" class="btn btn-primary" (click)="limpiarFiltros()">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section" role="complementary">
  <div class="container">
    <div class="cta-content">
      <h2 class="cta-title">¿No encuentras lo que buscas?</h2>
      <p class="cta-description">
        Sube tu CV y te notificaremos cuando aparezcan nuevas oportunidades que coincidan con tu perfil.
      </p>
      <div class="cta-actions">
        <a href="/para-candidatos" class="btn btn-primary btn-lg">
          <i class="fas fa-upload" aria-hidden="true"></i>
          Subir mi CV
        </a>
        <a href="/contacto" class="btn btn-outline-primary btn-lg">
          <i class="fas fa-envelope" aria-hidden="true"></i>
          Contactar Recursos Humanos
        </a>
      </div>
    </div>
  </div>
</section>
